module.exports = __webpack_public_path__ + "static/img/dsh3-2.ade0e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/readingDetail/dsh3-2.png
// module id = Olcn
// module chunks = 0